<!-- Copyright © 2024 Insurance Services Office, Inc. All rights reserved -->

<ng-select [items]="items" bindLabel="attributeName" bindValue="attributeId" [placeholder]="placeholder"
    [loading]="loading" [ngModel]="value" (ngModelChange)="onValueChange($event)">
    <ng-template ng-label-tmp let-item="item">
        <span *ngIf="item.datasetName" class="ng-value-label">{{'(' + item.datasetName + ') ' +
            item.attributeName}}</span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
        <span *ngIf="item.datasetName" class="ng-value-label">{{'(' + item.datasetName + ') ' +
            item.attributeName}}</span>
    </ng-template>
</ng-select>
